import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { qnaList } from "api/qna";
import { getCalendar } from "utils/date";

const today = new Date();
const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

const initialState = {
  isLoading: false,
  isMoreData: true,
  qnaList: [],
  fromTop: 0,
  activeTab: 0,
  totalQnACount: 0,
  waitQnACount: 0,
  completeQnACount: 0,
  searchCount: 0,
  startDt: getCalendar(firstDay),
  endDt: getCalendar(today),
  coachName: "전체 강사",
  seqPartnerCoach: "",
  period: "CURRENT_MONTH",
  searchTerm: "",
  page: 1,
  isError: false,
};

export const fetchQnaList = createAsyncThunk(
  "qna/fetchQnaList",
  async (payload) => {
    return await qnaList(payload);
  }
);

const qnaSlice = createSlice({
  name: "qna",
  initialState,
  reducers: {
    setResetState(state) {
      Object.assign(state, initialState);
    },
    setFromTop(state, action) {
      state.fromTop = action.payload;
    },
    setQnaList(state, action) {
      const { seqQna, answerCompleteYn } = action.payload;
      state.qnaList = state.qnaList.map((v) =>
        v.uploadId === seqQna ? { ...v, answerCompleteYn: answerCompleteYn } : v
      );
      if (answerCompleteYn === "Y") {
        state.waitQnACount = state.waitQnACount - 1;
        state.completeQnACount = state.completeQnACount + 1;
      }
      if (answerCompleteYn === "N") {
        state.waitQnACount = state.waitQnACount + 1;
        state.completeQnACount = state.completeQnACount - 1;
      }
    },
    setSearchCount(state, action) {
      state.searchCount = action.payload;
    },
    setSearchOption(state, action) {
      const { startDt, endDt, coachName, seqPartnerCoach, period, searchTerm } =
        action.payload;
      state.startDt = startDt;
      state.endDt = endDt;
      state.coachName = coachName;
      state.seqPartnerCoach = seqPartnerCoach;
      state.period = period;
      state.searchTerm = searchTerm;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQnaList.pending, (state, action) => {
        const { isAdd, qnaStatus, page } = action.meta.arg;
        if (isAdd) {
          state.isLoading = true;
        } else {
          state.isLoading = true;
          state.activeTab = qnaStatus;
          state.isMoreData = true;
          state.page = 1;
          state.fromTop = 0;
          state.qnaList = [];
        }
      })
      .addCase(fetchQnaList.fulfilled, (state, action) => {
        const { isAdd } = action.meta.arg;
        const {
          qnAs: data,
          totalQnACount,
          waitQnACount,
          completeQnACount,
        } = action.payload;
        if (isAdd) {
          state.qnaList = state.qnaList.concat(data.results);
        } else {
          state.qnaList = data.results;
        }
        state.isLoading = false;
        state.totalQnACount = totalQnACount;
        state.waitQnACount = waitQnACount;
        state.completeQnACount = completeQnACount;
        state.page = state.page + 1;
        if (data.last) {
          state.isMoreData = false;
        }
      })
      .addCase(fetchQnaList.rejected, (state) => {
        Object.assign(state, { ...initialState, isError: true });
      });
  },
});

export const {
  setResetState,
  setFromTop,
  setQnaList,
  setSearchCount,
  setSearchOption,
} = qnaSlice.actions;

export default qnaSlice.reducer;
